import { render, staticRenderFns } from "./StampTakenImage.vue?vue&type=template&id=cd4d40e6&scoped=true&"
import script from "./StampTakenImage.vue?vue&type=script&lang=js&"
export * from "./StampTakenImage.vue?vue&type=script&lang=js&"
import style0 from "./StampTakenImage.vue?vue&type=style&index=0&id=cd4d40e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4d40e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd4d40e6')) {
      api.createRecord('cd4d40e6', component.options)
    } else {
      api.reload('cd4d40e6', component.options)
    }
    module.hot.accept("./StampTakenImage.vue?vue&type=template&id=cd4d40e6&scoped=true&", function () {
      api.rerender('cd4d40e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/StampTakenImage.vue"
export default component.exports